import { Action, Error, EventName, Method, NO_VALUE, pageLoginSources, } from '../../constants.js';
export const buildFailedRequestErrorPayload = (payloadParams) => {
    const { componentTitle, loginSource, formFailedAttemptsErrors, componentState, } = payloadParams;
    const trackingPayload = {
        method: Method.LINK,
        triggeringEventPlace: {
            componentId: componentTitle,
            linkName: `${Error.FORM_VALIDATION}Error`,
        },
        trackingData: {
            eventName: EventName.ERROR,
            componentState: NO_VALUE,
            elementActioned: Error.FORM_VALIDATION,
            elementAction: Action.ERROR,
            elementActionValue: NO_VALUE,
            componentName: componentTitle,
            formFieldErrors: formFailedAttemptsErrors,
            loginSource: loginSource,
            allowLinkBeforeView: true,
            ...(componentState && { componentState }),
        },
    };
    if (!pageLoginSources.includes(loginSource)) {
        delete trackingPayload.trackingData.componentName;
    }
    return trackingPayload;
};
//# sourceMappingURL=buildFailedRequestErrorPayload.js.map